import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)

  const hasToken = localStorage.getItem('tokens')
  const hasGetUserInfo = store.getters.name
  const allCookies = document.cookie;
  console.log('hasToken',hasToken)
  if (hasToken) {
      //用户登录了还想去登录页
      if (to.path === '/login') {
        //将用户打回当前页
        next(false)
        NProgress.done()
      } else {
        //用户登录了想去别的页，如果有用户信息放行
        if (allCookies) {
          next()
        } else {
          //如果没有用户信息
          try {
            //异步获取用户信息，await获取成功放行
           //await store.dispatch('user/getInfo')
            next()
          } catch (error) {
            await store.dispatch('user/resetToken')
            Message.error(error || 'Has Error')
            next(`/login?redirect=${to.path}`)
            NProgress.done()
          }
        }
      }
      //用户未登录
    } else {
      //未登录想去登录页，放行
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        //未登录想去别的页面（除登录页外），跳转到登录后点过的那个页面
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
